module.exports = __webpack_public_path__ + "img/AT0000001823895.6919b6bb.svg";